import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Cookies from 'js-cookie'
import moment from 'moment'
import axios from './modules/axios'
import store from './store';
import VueInternationalization from 'vue-i18n';
import Locales from './lang/vue-i18n-locales.generated';

// Import assist intelligence fonts
import '@/assets/fonts/ai/css/style.css'

// router setup
import router from './routes/router';

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueInternationalization);

Vue.prototype.$cookies = Cookies;
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;

const i18n = new VueInternationalization({
    locale: Cookies.get('lang') || 'en',
    fallbackLocale: 'en',
    messages: Locales
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App),
});
